<template>
  <v-app>
    <component :is="componentName">
      <router-view />
    </component>

    <ChatHelp v-if="isAuth" />
    <ChangeUnityProfile />
    <Password />
    <Snackbar />
  </v-app>
</template>

<script>
import Layout from "@/views/ViewWithLayout.vue";
import NoLayout from "@/views/ViewWithoutLayout.vue";
import ChangeUnityProfile from "@/components/modules/users/change-unity-profile/ChangeUnityProfile.vue";
import Password from "@/components/modules/password/Password.vue";
import Snackbar from "@/components/widgets/notifications/Snackbar.vue";
import { BroadcastChannel } from "broadcast-channel";

export default {
  name: "App",

  computed: {
    componentName() {
      const routePath = this.$route.path;
      const routerOptions = this.$router.options;

      const routeData = routerOptions.routes.find(
        (route) => route.path === routePath
      );

      document.title = routeData
        ? ` ${routeData.completeName} | ${process.env.VUE_APP_TITLE}`
        : `Página não encontrada | ${process.env.VUE_APP_TITLE}`;

      const template = routeData ? routeData.template : false;
      return template ? "Layout" : "NoLayout";
    },

    isAuth() {
      const routePath = this.$route.path;
      const routerOptions = this.$router.options;

      const routeData = routerOptions.routes.find(
        (route) => route.path === routePath
      );

      return routeData ? routeData.permission : false;
    },
  },

  components: {
    Layout,
    NoLayout,
    ChangeUnityProfile,
    Password,
    Snackbar,
  },

  async mounted() {
    const channel = new BroadcastChannel("tabUpdateChannel");

    // Adiciona um listener para receber mensagens de outras abas
    channel.onmessage = (msg) => {
      if (msg === "UPDATE!") {
        location.reload(); // Atualiza a aba recarregando a página
      }
    };
  },
};
</script>
